export const MON_ENTREPRISE_ERROR_MESSAGES = {
  vatNumber: {
    required: 'Numéro de TVA obligatoire',
    vatNumber: 'Le numéro de TVA intracommunautaire est invalide',
  },
  siret: {
    required: 'SIRET obligatoire',
    siret: 'Le SIRET doit contenir exactement 14 chiffres',
  },
  industryType: {
    required: 'Ce champ est obligatoire',
  },
  legalStatus: {
    required: 'Ce champ est obligatoire',
    invalidOption:
      'Veuillez choisir une forme juridique parmi les options proposées',
  },
  name: {
    required: "Le nom de l'organisme est obligatoire.",
    minlength: (error: { requiredLength: number }) =>
      `Le nom de l'organisme doit contenir au moins ${error.requiredLength} caractères.`,
    maxlength: (error: { requiredLength: number }) =>
      `Le nom de l'organisme ne doit pas dépasser ${error.requiredLength} caractères.`,
  },
  address1: {
    required: 'Adresse obligatoire',
    maxlength: (error: { requiredLength: number }) =>
      `L'adresse ne doit pas dépasser ${error.requiredLength} caractères`,
  },
  address2: {
    maxlength: (error: { requiredLength: number }) =>
      `Le complément d'adresse ne doit pas dépasser ${error.requiredLength} caractères`,
  },
  address3: {
    maxlength: (error: { requiredLength: number }) =>
      `Le complément d'adresse ne doit pas dépasser ${error.requiredLength} caractères`,
  },
  city: {
    required: 'Ville obligatoire',
    maxlength: (error: { requiredLength: number }) =>
      `La ville ne doit pas dépasser ${error.requiredLength} caractères`,
  },
  postalCode: {
    required: 'Code postal obligatoire',
    maxlength: (error: { requiredLength: number }) =>
      `Le code postal ne doit pas dépasser ${error.requiredLength} caractères`,
  },
  phoneNumber: {
    worldPhoneNumber: 'Le numéro de téléphone est invalide',
  },
};

export const MES_INFORMATIONS_ERROR_MESSAGES = {
  firstname: {
    required: 'Prénom obligatoire',
    minlength: (error: { requiredLength: number }) =>
      `Le prénom doit contenir au moins ${error.requiredLength} caractères`,
    maxlength: (error: { requiredLength: number }) =>
      `Le prénom ne doit pas dépasser ${error.requiredLength} caractères`,
    firstname:
      'Le prénom ne peut contenir que des lettres, espaces, tirets et apostrophes',
  },
  lastname: {
    required: 'Nom obligatoire',
    minlength: (error: { requiredLength: number }) =>
      `Le nom doit contenir au moins ${error.requiredLength} caractères`,
    maxlength: (error: { requiredLength: number }) =>
      `Le nom ne doit pas dépasser ${error.requiredLength} caractères`,
    lastname:
      'Le nom ne peut contenir que des lettres, espaces, tirets et apostrophes',
  },
  email: {
    required: 'Email obligatoire',
    maxlength: (error: { requiredLength: number }) =>
      `L’email ne doit pas dépasser ${error.requiredLength} caractères`,
    email: 'Veuillez saisir une adresse email valide',
  },
  login: {
    required: 'Identifiant obligatoire',
    maxlength: (error: { requiredLength: number }) =>
      `L’identifiant ne doit pas dépasser ${error.requiredLength} caractères`,
    invalidLogin:
      "L'identifiant ne peut contenir que des lettres minuscules, chiffres, points, tirets et underscores, sans espace",
  },
};

export const MES_DETAILS_DOSSIER_EDIT_MODE_ERROR_MESSAGES = {
  reference: {
    maxlength: (error: { requiredLength: number }) =>
      `La référence du dossier ne doit pas dépasser ${error.requiredLength} caractères`,
    referencesValidator:
      'La référence du dossier ne doit pas contenir les caractères suivants : \\ / : * ? " < > |  ou d’espace',
  },
};
